import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert, Link, Heading3, Text, StackView, Heading1 } from 'localmed-core';

import { Fade, Scaleup, TransitionGroup } from '../../legacyCore/Transitions';
import style from './ForceSelection.scss';

export default class ForceSelection extends React.Component {
  state = {
    showAdditionalInfo: false,
  };

  onClick = () => {
    this.setState(({ showAdditionalInfo }) => ({ showAdditionalInfo: !showAdditionalInfo }));
  };

  render() {
    const { children, selected } = this.props;
    const { showAdditionalInfo } = this.state;
    return (
      <div
        className={classNames(
          style['force-selection'],
          selected && style['force-selection--selected'],
          showAdditionalInfo && style['force-selection--with-additional-info']
        )}
      >
        <TransitionGroup>
          {!selected && (
            <Fade key="MESSAGE" duration={100}>
              <div className={style['force-selection__message']}>
                <Heading1
                  data-qa="force-selection__message-title"
                  marginTop="lg"
                  marginBottom="xs"
                  fontWeight="bold"
                  fontSize={{ _: 'lg', md: 'xxl' }}
                >
                  Please Make a Selection Above
                </Heading1>
                <Text marginBottom="sm">
                  Before we can show you available appointments we need to know what you are looking
                  for.
                </Text>
                {showAdditionalInfo ? (
                  <Scaleup in>
                    <Alert
                      className={style['force-selection__additional-info']}
                      data-qa="force-force-selection__additional-info"
                      tier="success"
                      icon={false}
                    >
                      <StackView spacing="sm">
                        <Heading3 color="inherit">
                          We want to get your perfect appointment.
                        </Heading3>
                        <Text>
                          Telling us what type of appointment you’re looking for allows us to show
                          you the right appointment times so that we can get you scheduled right
                          away. So what are you waiting for? Choose your appointment type above.
                        </Text>
                      </StackView>
                    </Alert>
                  </Scaleup>
                ) : (
                  <Text>
                    <Link data-qa="force-selection__additional-info-button" onClick={this.onClick}>
                      Why do we need this information?
                    </Link>
                  </Text>
                )}
              </div>
            </Fade>
          )}
        </TransitionGroup>
        <div className={style['force-selection__content']}>{children}</div>
      </div>
    );
  }
}

ForceSelection.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
};
